import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import TemplateDashboardService from '../../Services/TemplateDashboardService';
import DeleteWidgetModalDisplay from './DeleteWidgetModalDisplay';

export default class DeleteWidgetModal extends Component {
  static propTypes = {
    asset: PropTypes.shape({ gtemplateID: PropTypes.string }),
    dashboardID: PropTypes.string,
    isOpen: PropTypes.bool,
    handleWidgetDeleted: PropTypes.func,
    toggleModal: PropTypes.func,
    widget: PropTypes.shape({ _id: PropTypes.string }),
  };

  state = { error: '', deleteRequestPending: false };
  source = CancelToken.source();

  service = new TemplateDashboardService();

  componentWillUnmount() {
    this.source.cancel();
  }

  handleWidgetDelete = async () => {
    this.setState({ deleteRequestPending: true });
    try {
      const {
        asset: { gtemplateID },
        dashboardID,
        handleWidgetDeleted,
        widget: { _id: widgetID },
      } = this.props;
      await this.service.deleteTemplateDashboardWidget(
        gtemplateID,
        dashboardID,
        widgetID,
        this.source.token
      );

      this.setState({ deleteRequestPending: false }, () => {
        handleWidgetDeleted(widgetID);
      });
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      this.setState({ error, deleteRequestPending: false });
    }
  };
  render() {
    return (
      <DeleteWidgetModalDisplay
        {...this.props}
        {...this.state}
        handleWidgetDelete={this.handleWidgetDelete}
      />
    );
  }
}
